import * as React from 'react'
import { connect } from 'react-redux'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { PurchaseButton, PrimeButton } from '@amzn/dvui/dist/Button'
import { Text } from '@amzn/dvui/dist/Text'
import * as cn from 'classnames'
import { sanitizedRequestContextSelector } from '../../selectors/requestContext'
import { IDetailPageState } from '../../reducers'
import * as utilityClasses from '../utilityClasses.module.scss'
import * as hoverClasses from '../../widgets/Hover/hoverComponent.module.scss'

type ISvodButton = {
  svodAction: WpsRuntime.atv.wps.SubscribeActionProps
  className?: string
  forceDoubleHeight?: boolean
} & ReturnType<typeof mapStateToProps>

export const ConnectedSvodButton = ({ svodAction, requestContext: { isRetail }, className, forceDoubleHeight }: ISvodButton) => {
  const Tag =
    svodAction.sType === 'PRIME' && !isRetail ? PrimeButton : PurchaseButton
  return (
    <Tag
      className={cn({ [className!]: !!className }, utilityClasses.fullWidthPhablet, hoverClasses.buttonOverride, 'dv-signup-button')}
      href={svodAction.signupLink}
      forceDoubleHeight={forceDoubleHeight}
    >
      <Text string={svodAction.label} />
    </Tag>
  )
}

const mapStateToProps = (state: IDetailPageState) => ({
  requestContext: sanitizedRequestContextSelector(state)
})

export const SvodButton = connect(mapStateToProps)(ConnectedSvodButton)
